import { render } from "./WellcomeUserView.vue?vue&type=template&id=ec71d0d6"
import script from "./welcome-user-view?vue&type=script&lang=js&external"
export * from "./welcome-user-view?vue&type=script&lang=js&external"

import "./WellcomeUserView.vue?vue&type=style&index=0&id=ec71d0d6&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.89.0_@swc+core@1.12.7_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/wellcome/WellcomeUserView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec71d0d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec71d0d6', __exports__)) {
    api.reload('ec71d0d6', __exports__)
  }
  
  module.hot.accept("./WellcomeUserView.vue?vue&type=template&id=ec71d0d6", () => {
    api.rerender('ec71d0d6', render)
  })

}


export default __exports__